import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "classNames", "styles", "unstyled", "className", "color", "padding", "length", "width"];
import { jsx } from 'react/jsx-runtime';
import cx from 'classnames';
import useStyles from './Target.styles.js';
var Target = function Target(_ref) {
  var children = _ref.children,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#5CCBCB" : _ref$color,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 4 : _ref$padding,
    _ref$length = _ref.length,
    length = _ref$length === void 0 ? 8 : _ref$length,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 1 : _ref$width,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      color: color,
      padding: padding,
      length: length,
      width: width
    }, {
      name: "Target",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes;
  return /* @__PURE__ */jsx("span", _objectSpread(_objectSpread({
    className: cx(classes.root, className)
  }, others), {}, {
    children: /* @__PURE__ */jsx("span", {
      className: classes.target1,
      children: /* @__PURE__ */jsx("span", {
        className: classes.target2,
        children: children
      })
    })
  }));
};
export { Target };